<template>
  <li class="nav-item dropdown">
    <a
      class="nav-link dropdown-toggle"
      href="javascript:void(0);"
      id="navbar-order-of-service-selection"
      role="button"
      data-bs-toggle="dropdown"
      aria-expanded="false"
    >
      {{
        selected_order_of_service == null
          ? 'Selecione uma ordem de serviço'
          : selected_order_of_service.name
      }}
    </a>
    <div
      class="dropdown-menu"
      aria-labelledby="navbar-order-of-service-selection"
      id="ordersOfServiceDropdownScroll"
    >
      <div class="search">
        <input
          type="text"
          v-model="dropdown_order_of_service_filters.name"
          placeholder="Selecione ou pesquise"
        />
      </div>
      <div class="content" @scroll="onOrdersOfServiceDropdownScroll" v-if="selected_company">
        <a
          v-for="row in dropdown_orders_of_service"
          :key="row.order_of_service_id"
          class="dropdown-item"
          href="javascript:void(0);"
          @click.prevent="onSelectOrderOfService(row.order_of_service_id)"
          >{{ row.name }}</a
        >

        <div
          class="no-content dropdown-item"
          v-if="dropdown_orders_of_service?.length === 0"
        >
          Nenhum resultado encontrado...
        </div>
      </div>
      <div class="m-3" v-else>
        Selecione uma empresa para ver suas ordens de serviço
      </div>
    </div>
  </li>
</template>

<script>
  import { computed, onMounted } from 'vue'
  import { useStore } from 'vuex'
  import useOrdersOfServiceDropdown from '@/modules/OrderOfServiceDropdown.js'

  export default {
    name: 'App',
    setup() {
      const {
        dropdown_orders_of_service,
        dropdown_order_of_service_filters,
        onOrdersOfServiceDropdownScroll,
        loadNextOrdersOfServicePage,
      } = useOrdersOfServiceDropdown()

      const store = useStore()

      const selected_company = computed(() => store.getters.selected_company)
      const selected_order_of_service = computed(() => store.getters.selected_order_of_service)

      const onSelectOrderOfService = (order_of_service_id) => {
        store
          .dispatch('selectOrderOfService', order_of_service_id)
          .then(() => {})
          .catch(() => {})
      }

      return {
        selected_company,
        dropdown_orders_of_service,
        dropdown_order_of_service_filters,
        onOrdersOfServiceDropdownScroll,
        onSelectOrderOfService,
        selected_order_of_service,
      }
    },
    mounted() {
      if (this.selected_company) {
        this.dropdown_order_of_service_filters.company_id = this.selected_company.id
      }
    },
    watch: {
      selected_company() {
        if (this.selected_company) {
          this.dropdown_order_of_service_filters.company_id = this.selected_company.id
        }
      }
    }
  }
</script>

<style lang="scss" scoped>
  div#ordersOfServiceDropdownScroll {
    height: auto;
    max-width: 370px;
    min-width: 300px;

    .search {
      display: flex;
      justify-content: center;
      align-items: center;
      margin: 10px 24px;

      input {
        width: 100%;
      }
    }

    .content {
      max-height: 300px;
      overflow-y: scroll;
    }
  }
</style>
